import React from "react";
import styles from "./reader.module.css";

export default function MediaRenderer({ type, videoUrl, content }) {
  if (type === "video" && videoUrl) {
    const isYouTube = /youtube|youtu\.be/.test(videoUrl);
    const isVimeo = /vimeo/.test(videoUrl);
    const src = videoUrl; // pega la URL embebible
    return <iframe className={styles.video} src={src} allow="autoplay; fullscreen; picture-in-picture" title="video" />;
  }
  // texto/HTML
  return <div className={`${styles.text} ${styles.card}`} dangerouslySetInnerHTML={{ __html: content || "" }} />;
}
